import _ from 'lodash'
import {ElNotification} from 'element-plus'
import {useReportStore} from "@/stores/report";

const bar = {
    backgroundColor: '',
    title: {
        show: true,
        left: 'left', //主标题文本，支持使用 \n 换行
        text: 'Bar Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '',
        sublink: '',
        subtarget: 'blank',
        subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal',
            lineHeight: '',
            width: 150, //truncate/break/breakAll
            overflow: 'none',
            ellipsis: '...',
            height: 'none', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    }, //提示框组件
    tooltip: {
        show: true, /**
         * 'item' 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
         * 'axis' 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
         * 'none' 什么都不触发。
         */
        trigger: 'axis', //提示框触发的条件 mousemove/click/mousemove|click/none
        triggerOn: 'mousemove|click', //tooltip 中数值显示部分的格式化回调函数
        valueFormatter: function (value) {
            return value + ""
        }, //seriesAsc/seriesDesc/valueAsc/valueDesc
        order: 'seriesAsc'
    },
    legend: {
        show: true, textStyle: {
            color: 'rgba(19, 33, 79, 1)',
        }, //'plain'：普通图例。缺省就是普通图例。 'scroll'：可滚动翻页的图例。当图例数量较多时可以使用
        type: 'plain', width: 'auto', height: 'auto', //图例组件离容器左侧的距离 ,left 的值可以是像 20 这样的具体像素值，可以是像 '20%' 这样相对于容器高宽的百分比，也可以是 'left', 'center', 'right'
        left: 'center', //horizontal/vertical
        orient: 'horizontal', //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔
        itemGap: 10, top: 'auto', bottom: 'auto',
    },
    grid: {
        left: '12%', right: '6%', top: 60, bottom: 60, containLabel: false,
    },
    dataset: {
        dimensions: ['product', '2015', '2016', '2017'],
        source: [{product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7}, {
            product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1
        }, {product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5}, {
            product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1
        }]
    },
    series: [
        {
            type: 'bar',
            label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2
            }
        }, {
            type: 'bar',
            label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2,
            }
        }, {
            type: 'bar',
            label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2,
            },
        }],
    xAxis: {
        type: 'category', //是否显示X轴
        show: true, //网格分割线
        splitLine: {
            show: false
        }, //坐标轴线
        axisLine: {
            show: false,
        }, //坐标刻度
        axisTick: {
            show: false
        }, axisLabel: {
            //是否显示刻度标签
            show: true, color: null, /**
             * 坐标轴刻度标签的显示间隔，在类目轴中有效。
             * 默认auto会采用标签不重叠的策略间隔显示标签。
             * 可以设置成 0 强制显示所有标签。
             * 如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
             */
            interval: 'auto', /**
             * 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度。
             */
            rotate: 0, //使用字符串模板，模板变量为刻度默认标签 {value}
            formatter: '{value}'
        },
    },
    yAxis: {
        show: true, min: 0, //坐标轴线
        axisLine: {
            show: false
        }, //坐标刻度
        axisTick: {
            show: false
        }, //网格分割线
        splitLine: {
            show: false
        }, axisLabel: {
            //是否显示刻度标签
            show: true, color: null, /**
             * 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度。
             */
            rotate: 0, //使用字符串模板，模板变量为刻度默认标签 {value}
            formatter: '{value}'
        },
    },
    seriesLabel: {
        isShowLabel: false,
        labelPosition: 'top',
        labelColor: 'rgba(19, 33, 79, 1)',
        labelFontSize: 12,
        labelBorderColor: 'transparent',
        labelBorderWidth: 2,
    }
}
const line = {
    backgroundColor: '',
    title: {
        show: true, left: 'left', //主标题文本，支持使用 \n 换行
        text: 'Bar Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', lineHeight: '', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    }, //提示框组件
    tooltip: {
        show: true, /**
         * 'item' 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
         * 'axis' 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
         * 'none' 什么都不触发。
         */
        trigger: 'axis', //提示框触发的条件 mousemove/click/mousemove|click/none
        triggerOn: 'mousemove|click', //tooltip 中数值显示部分的格式化回调函数
        valueFormatter: function (value) {
            return value + ""
        }, //seriesAsc/seriesDesc/valueAsc/valueDesc
        order: 'seriesAsc'
    },
    legend: {
        show: true, textStyle: {
            color: 'rgba(19, 33, 79, 1)',
        }, //'plain'：普通图例。缺省就是普通图例。 'scroll'：可滚动翻页的图例。当图例数量较多时可以使用
        type: 'plain', width: 'auto', height: 'auto', //图例组件离容器左侧的距离 ,left 的值可以是像 20 这样的具体像素值，可以是像 '20%' 这样相对于容器高宽的百分比，也可以是 'left', 'center', 'right'
        left: 'center', //horizontal/vertical
        orient: 'horizontal', //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔
        itemGap: 10, top: 'auto', bottom: 'auto',
    },
    dataset: {
        dimensions: ['product', '2015', '2016', '2017'],
        source: [{product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7}, {
            product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1
        }, {product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5}, {
            product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1
        }]
    },
    grid: {
        left: '12%', right: '2%', top: 60, bottom: 50, containLabel: false,
    },
    series: [
        {
            type: 'line', smooth: true, symbolSize: 8, label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2
            }
        },
        {
            type: 'line', smooth: true, symbolSize: 8, label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2
            }
        },
        {
            type: 'line', smooth: true, symbolSize: 8, label: {
                show: false,
                position: 'top',
                color: 'rgba(19, 33, 79, 1)',
                fontSize: 12,
                textBorderColor: 'transparent',
                textBorderWidth: 2,
                barGap: "-100%"
            }
        }],
    xAxis: {
        type: 'category', //是否显示X轴
        show: true, //网格分割线
        splitLine: {
            show: false
        }, //坐标轴线
        axisLine: {
            show: false,
        }, //坐标刻度
        axisTick: {
            show: false
        }, axisLabel: {
            //是否显示刻度标签
            show: true, color: null, /**
             * 坐标轴刻度标签的显示间隔，在类目轴中有效。
             * 默认auto会采用标签不重叠的策略间隔显示标签。
             * 可以设置成 0 强制显示所有标签。
             * 如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
             */
            interval: 'auto', /**
             * 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度。
             */
            rotate: 0, //使用字符串模板，模板变量为刻度默认标签 {value}
            formatter: '{value}'
        },
    },
    yAxis: {
        show: true, min: 'dataMin', //坐标轴线
        axisLine: {
            show: false
        }, //坐标刻度
        axisTick: {
            show: false
        }, //网格分割线
        splitLine: {
            show: false
        }, axisLabel: {
            //是否显示刻度标签
            show: true, color: null, /**
             * 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度。
             */
            rotate: 0, //使用字符串模板，模板变量为刻度默认标签 {value}
            formatter: '{value}'
        },
    },
    smooth: true,
    area: false,
    stack: false,
    symbolSize: 8,
    seriesLabel: {
        isShowLabel: false,
        labelPosition: 'top',
        labelColor: 'rgba(19, 33, 79, 1)',
        labelFontSize: 12,
        labelBorderColor: 'transparent',
        labelBorderWidth: 2,
    }
}
const pie = {
    backgroundColor: '',
    title: {
        show: true, left: 'center', //主标题文本，支持使用 \n 换行
        text: 'Pie Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2, textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', lineHeight: '', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    }, //提示框组件
    tooltip: {
        show: true,
        /**
         * 'item' 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
         * 'axis' 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
         * 'none' 什么都不触发。
         */
        trigger: 'item', //提示框触发的条件 mousemove/click/mousemove|click/none
        triggerOn: 'mousemove|click', //seriesAsc/seriesDesc/valueAsc/valueDesc
        order: 'seriesAsc'
    },
    grid: {
        left: '12%', right: '6%', top: 60, bottom: 60, containLabel: false,
    },
    legend: {
        show: true, textStyle: {
            color: 'rgba(19, 33, 79, 1)',
        }, //'plain'：普通图例。缺省就是普通图例。 'scroll'：可滚动翻页的图例。当图例数量较多时可以使用
        type: 'plain', //图例组件离容器左侧的距离 ,left 的值可以是像 20 这样的具体像素值，可以是像 '20%' 这样相对于容器高宽的百分比，也可以是 'left', 'center', 'right'
        left: 'left', //horizontal/vertical
        orient: 'vertical', width: 'auto', height: 'auto', //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔
        itemGap: 10, top: 'auto', bottom: 'auto',
    },
    dataset: {
        source: [
            {value: 848, name: 'Search Engine'},
            {value: 735, name: 'Direct'},
            {value: 580, name: 'Email'},
            {value: 484, name: 'Union Ads'},
            {value: 300, name: 'Video Ads'},]
    },
    series: [{
        type: 'pie', radius: '50%', label: {
            show: true, color: 'rgba(19, 33, 79, 1)',
        }, labelLine: {
            show: true
        }, encode: {
            itemName: "name", value: "value"
        },
    },],
    type: 'normal',
}
const radar = {
    backgroundColor: '',
    title: {
        show: true, left: 'left', //主标题文本，支持使用 \n 换行
        text: 'Radar Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', lineHeight: '', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    }, //提示框组件
    tooltip: {
        show: true, /**
         * 'item' 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
         * 'axis' 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
         * 'none' 什么都不触发。
         */
        trigger: 'item', //提示框触发的条件 mousemove/click/mousemove|click/none
        triggerOn: 'mousemove|click', //seriesAsc/seriesDesc/valueAsc/valueDesc
        order: 'seriesAsc'
    },
    legend: {
        show: false, textStyle: {
            color: 'rgba(19, 33, 79, 1)',
        }, //'plain'：普通图例。缺省就是普通图例。 'scroll'：可滚动翻页的图例。当图例数量较多时可以使用
        type: 'plain', width: 'auto', height: 'auto', //图例组件离容器左侧的距离 ,left 的值可以是像 20 这样的具体像素值，可以是像 '20%' 这样相对于容器高宽的百分比，也可以是 'left', 'center', 'right'
        left: 'center', //horizontal/vertical
        orient: 'horizontal', //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔
        itemGap: 10, top: 'auto', bottom: 'auto',
    },
    radar: {
        //圆心xy偏移
        center: ['50%', '50%'], //内外半径
        radius: [10, '75%'], //坐标系起始角度
        startAngle: 90, //指示器名称和指示器轴的距离。
        axisNameGap: 10, //轴线
        axisLine: {
            show: true,
        }, //坐标轴刻度标签
        axisLabel: {
            showMinLabel: false, show: false, rotate: 0, color: null,
        }, //指示器名称
        axisName: {
            show: true,
            formatter: '{value}',
            color: '#6E7078',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 12,
            padding: 4,
            backgroundColor: null,
        }, //雷达图绘制类型，支持 'polygon' 和 'circle'
        shape: 'polygon', indicator: [{
            name: 'Sales',
        }, {
            name: 'Administration',
        }, {
            name: 'Information Technology',

        }, {
            name: 'Customer Support',
        }, {
            name: 'Development',
        }, {
            name: 'Marketing',
        }]
    },
    series: [{
        type: 'radar', data: [{
            name: 'Allocated Budget', value: [4200, 3000, 20000, 35000, 50000, 18000],
        }, {
            name: 'Actual Spending', value: [5000, 14000, 28000, 26000, 42000, 21000],
        }]
    }],
    area: false,
}
const water = {
    backgroundColor: '',
    title: {
        show: false, left: 'left', //主标题文本，支持使用 \n 换行
        text: 'Water Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', lineHeight: '', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    },
    series: [{
        type: 'liquidFill', data: [0.25],
        label: {
            color: '#4f4f4f',
            fontSize: 20 //修改字体大小
        },
        color: [{
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{
                offset: 0, color: 'rgba(0, 206, 209, 0.3)' // 0% 处的颜色
            }, {
                offset: 1, color: 'rgba(0, 206, 209, 0.56)' // 100% 处的颜色
            }], // 缺省为 false
            global: false
        }], backgroundStyle: {
            borderWidth: 2, borderColor: 'rgba(255,255,255,0.1)', //背景色
            color: 'rgba(255,255,255,1)',
        }, outline: {
            borderDistance: 0, itemStyle: {
                //外圈颜色
                borderColor: 'rgba(0, 186, 189, 1)', borderWidth: 6
            },
        }
    }]
}
const gauge = {
    backgroundColor: '',
    title: {
        show: true, left: 'left', //主标题文本，支持使用 \n 换行
        text: 'Gauge Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', lineHeight: '', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    },
    series: [
        {
            type: 'gauge', //起始角度
            startAngle: 210, //结束角度
            endAngle: -30, min: 0, max: 1, splitNumber: 8, axisLine: {
                lineStyle: {
                    //仪表盘宽度
                    width: 6, color: [[0.25, '#FF6E76'], [0.5, '#FDDD60'], [0.75, '#58D9F9'], [1, '#7CFFB2']]
                }
            }, pointer: {
                icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z', //指针长度
                length: '20%', //指针宽度
                width: 16, offsetCenter: [0, '-60%'], itemStyle: {
                    color: 'inherit'
                }
            }, axisTick: {
                //刻度长度
                length: 6, lineStyle: {
                    color: 'inherit', //刻度宽度
                    width: 2
                }
            }, splitLine: {
                //分割线长度
                length: 20, lineStyle: {
                    color: 'inherit', //分割线宽度
                    width: 5
                }
            }, axisLabel: {
                show: false,
            }, title: {
                offsetCenter: [0, '-20%'], fontSize: 14
            }, detail: {
                //数值显示
                show: true, //文本字体
                fontSize: 24, offsetCenter: [0, '0%'], valueAnimation: true, formatter: function (value) {
                    return Math.ceil(value * 100) + '%'
                }, color: 'inherit'
            }, data: [{
                value: 0.7,
            }]
        }],
}
const capsule = {
    unit: ' ',
    showValue: true,
    color: 'rgba(19, 33, 79, 1)',
    backgroundColor: 'transparent',
    colors: [],
    data: [{name: 'Chinese', value: 15}, {name: 'English', value: 9.8}, {name: 'Spain', value: 5.7}, {
        name: 'Hindi', value: 5.44
    }, {name: 'Arabic', value: 4.22},]
}
const scrollTable = {
    header: ['Company', 'Market Value'],
    data: [['APPLE', '28500'],
        ['MICROSOFT', '23110'], ['SAUDI ARABIAN OI', '22980'], ['ALPHABET INC', '18420'], ['AMAZON.COM INC', '16590'], ['TESLA', '11140'], ['BERKSHIRE', '7800'], ['NVIDIA', '6850'], ['META PLAFORMS', '6050'], ['TSMC', '5410']], //表行数
    rowNum: 5, //表头背景色
    headerBGC: 'rgb(0,59,81)', //奇数行背景色
    oddRowBGC: '#003B51', //偶数行背景色
    evenRowBGC: '#0A2732', //轮播时间间隔(ms)
    waitTime: 2000,
    headerSize: 12,
    headerHeight: 35, //表头高度
    columnSize: 12,
    columnWidth: [50], //列宽度
    align: ['center', 'center', 'center'], //列对齐方式 'left'|'center'|'right'，默认值为'left'
    index: true, //显示行号/
    indexHeader: '#', //行号表头
    carousel: 'single',//'single'|'page'
    hoverPause: true,//悬浮暂停轮播
    headerColor: 'rgb(255,255,255)',
    dataColor: 'rgb(255,255,255)',
    sum: false,
}
const table = {
    height: '200px',
    border: true,//是否带有纵向边框
    size: 'mini', //medium / small / mini
    showHeader: true,//是否显示表头
    highlightCurrentRow: true,
    emptyText: '暂无数据',
    sum: false,
    sumIgnore: '',
    index: true,
    align: 'center',
    headerStyle: {
        height: 20,
        backgroundColor: 'rgb(255,255,255,1)',
        textColor: 'rgb(0,0,0,1)',
        textSize: 14,
    },
    bodyStyle: {
        height: 20,
        oddBackgroundColor: 'rgb(255,255,255,1)',
        evenOddBackgroundColor: '#FAFAFA',
        textColor: '#88898C',
        textSize: 13,
        widths: [],
    },
    data: [{
        姓名: '王小虎',
        地址: '上海市普陀区金沙江路 1518 弄',
        生日: '2016-05-02',
    }, {
        姓名: '王小虎',
        地址: '上海市普陀区金沙江路 1517 弄',
        生日: '2016-05-04',
    }, {
        姓名: '王小虎',
        地址: '上海市普陀区金沙江路 1519 弄',
        生日: '2016-05-01',
    }, {
        姓名: '王小虎',
        地址: '上海市普陀区金沙江路 1516 弄',
        生日: '2016-05-03',
    }],
}
const border = {
    index: 1,
}
const wordCloud = {
    title: {
        show: true, left: 'left', //主标题文本，支持使用 \n 换行
        text: 'WordCloud Chart', //整体（包括 text 和 subtext）的水平对齐,'auto'、'left'、'right'、'center'
        textAlign: 'auto', //整体（包括 text 和 subtext）的垂直对齐。可选值：'auto'、'top'、'bottom'、'middle'。
        textVerticalAlign: 'auto', //是否显示标题组件
        //主标题文本超链接
        link: '', //指定窗口打开主标题超链接, 'self' 当前窗口打开/ 'blank' 新窗口打开
        target: 'blank', //是否触发事件
        triggerEvent: false, //标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。
        padding: 5, //主副标题之间的间距
        itemGap: 10, //组件的所有图形的z值。控制图形的前后顺序。z值小的图形会被z值大的图形覆盖
        z: 2,
        textStyle: {
            //主标题文字字体的风格 normal、italic、oblique
            fontStyle: 'normal', //主标题文字字体的粗细，normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'bolder', //主标题文字的字体系列
            fontSize: 18, //文本显示宽度 number
            color: 'rgba(19, 33, 79, 1)',
            width: 'none', /**
             * 文字超出宽度是否截断或者换行配合width使用
             * 'truncate' 截断，并在末尾显示ellipsis配置的文本，默认为...
             * 'break' 换行
             * 'breakAll' 换行，跟'break'不同的是，在英语等拉丁文中，'breakAll'还会强制单词内换行
             */
            overflow: 'none', //在overflow配置为'truncate'的时候，可以通过该属性配置末尾显示的文本
            ellipsis: '...', //文字本身的描边宽度
            textBorderWidth: 1,
        }, /**
         * 子标题相关属性
         */
        subtext: '', sublink: '', subtarget: 'blank', subtextStyle: {
            fontSize: 12, //normal/italic/oblique
            color: 'rgba(19, 33, 79, 1)',
            fontStyle: 'normal', lineHeight: '', width: 150, //truncate/break/breakAll
            overflow: 'none', ellipsis: '...', height: 'none', //normal、bold、bolder、lighter、100|200|300|400
            fontWeight: 'normal', //副标题文字的字体系列
            align: 'left', //top/middle/bottom
            verticalAlign: 'middle',
        }
    },
    series: [{
        type: 'wordCloud', left: 'center',                 // X轴偏移量
        top: 'center',                  // Y轴偏移量
        width: '100%',               // canvas宽度大小
        height: '100%',              // canvas高度大小
        sizeRange: [20, 50],         //  词典字体大小范围配置
        rotationRange: [0, 20],// 词典字体旋转角度配置，默认不旋转
        gridSize: 25,                // 词典字体间距配置
        layoutAnimation: true,       // 为false词典过度会阻塞
        textStyle: {
            color: function () {
                return 'rgb(' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ')'
            }
        }, data: [{value: 50, name: 'Samsung'}, {value: 30, name: 'Apple'}, {value: 29, name: 'Xiaomi'}, {
            value: 28, name: 'Vivo'
        }, {value: 27, name: 'Oppo'}, {value: 26, name: 'Realme'}, {value: 25, name: 'Motorala'}, {
            value: 24, name: 'Honor'
        }, {value: 23, name: 'Huawei'}, {value: 22, name: 'Tecno'}, {value: 21, name: 'Others'}]
    }]

}
const word = {
    url: '',
    text: '默认文本',
    fontSize: 16,
    fontWeight: 'normal',
    textAlign: 'center',
    color: 'rgba(30, 144, 255, 1)',
    textShadowSize: 6,
    textShadowColor: 'rgba(255,255,255,0)',
    textDecoration: 'none',
    cursor: 'default',

}
const card = {
    url: '',
    title: '指标卡',
    backgroundColor: '#8184E9',
    text: '默认文本',
    suffix: '个',
    fontSize: 16,
    fontWeight: 'normal',
    textAlign: 'center',
    color: 'rgba(30, 144, 255, 1)',
    textShadowSize: 6,
    textShadowColor: 'rgba(255,255,255,0)',
    textDecoration: 'none',
    cursor: 'default',
}
const timeFilter = {}
const photo = {
    imageId: '',
    opacity: 1,
}
const dropDownFilter = {
    value: '', options: [], multiple: false, width: '170px',
}
const website = {
    url: '', scrolling: 'no', frameborder: 1,
}
const wall = {
    'backgroundColor': 'rgba(207, 196, 196, 0.21)',
    'borderSize': 1,
    'borderColor': 'red',
    'borderType': 'none',
    'borderRadius': '6'
}
const amap = {
    style: 'darkblue',
    center: [105.602725, 37.076636],
    //视角
    pitch: 40,
    rotation: 0,
    showLabel: true,
    zoom: 11.5,
    zooms: [11, 14],
    layers: [],
}
const timer = {
    type: 'current',//以后追加倒计时
    fontSize: 16,
    format: 'yyyy-MM-dd HH:mm:ss',
    fontWeight: 'normal',
    textAlign: 'center',
    color: 'rgba(30, 144, 255, 1)',
    textShadowSize: 6,
    textShadowColor: 'rgba(255,255,255,0)',
    textDecoration: 'none',
}
const gantt = {
    data: [
        {
            id: 1,
            text: "Project #1",
            start_date: "2019-08-01 00:00",
            end_date: "2019-08-12 00:00",
            parent: 0,
            "name": 'name1',
            progress: 0,
            open: true
        },
        {
            id: 2,
            text: "Task #1",
            start_date: "2019-08-01 00:00",
            end_date: "2019-08-05 23:59",
            "name": 'name2',
            parent: 1,
            progress: 0
        },
        {
            id: 3,
            text: "Task #2",
            start_date: "2019-08-06 00:00",
            end_date: "2019-08-07 23:59",
            "name": 'name3',
            parent: 1,
            progress: 0
        },
        {
            id: 4,
            text: "Task #3",
            start_date: "2019-08-09 00:00",
            end_date: "2019-08-12 00:00",
            parent: 1,
            "name": 'name4',
            progress: 0,
            open: true
        },
        {
            id: 5,
            text: "Task #3.1",
            start_date: "2019-08-09 00:00",
            end_date: "2019-08-11 00:00",
            "name": 'name5',
            parent: 4,
            progress: 0
        },
        {
            id: 6,
            text: "Task #3.2",
            start_date: "2019-08-11 00:00",
            end_date: "2019-08-12 00:00",
            "name": 'name6',
            parent: 4,
            progress: 0
        }
    ],
    links: [
        {id: 1, source: 2, target: 3, type: "3"},
        {id: 2, source: 3, target: 4, type: "3"},
        {id: 3, source: 5, target: 6, type: "3"}
    ],
}


export default {
    dataset() {
        return {
            datasource: {
                type: 'Model',
                value: '',
                columns: [],
            },
            dimensions: [],
            indices: [],
            extensions: [],
            quickLook: [],
            diving: "",
            diving_column: '',
            diving_condition: 'EQUALS',
            diving_value: '',
            filters: [],
            limit: {
                sorts: 'ASC', count: 0,
            },
            sort: {
                sorts: 'ASC',
                value: '',
            },
            summaryWays: [],
            formats: []
        }
    },
    changeThemeBar(chart) {
        delete chart.option.legend.textStyle.color
        chart.option.xAxis.axisLabel.color = null
        chart.option.yAxis.axisLabel.color = null

    },
    changeThemeLine(chart) {
        delete chart.option.legend.textStyle.color
        chart.option.xAxis.axisLabel.color = null
        chart.option.yAxis.axisLabel.color = null
    },
    changeThemePie(chart) {
        delete chart.option.legend.textStyle.color
    },
    changeThemeRadar(chart) {
        delete chart.option.legend.textStyle.color
        chart.option.radar.axisLabel.color = null
        chart.option.radar.axisName.color = null
    },
    changeThemeCapsule(chart, theme) {
        if (theme === 'dark') {
            chart.option.color = '#ebebeb'
            chart.option.backgroundColor = 'rgb(16,12,42)'
        } else {
            chart.option.color = 'rgba(19, 33, 79, 1)'
            chart.option.backgroundColor = 'transparent'
        }
    },
    gantt() {
        return _.cloneDeep(gantt);
    },
    table() {
        return _.cloneDeep(table)
    },
    timeFilter() {
        return _.cloneDeep(timeFilter)
    },
    bar() {
        return _.cloneDeep(bar)
    },
    line() {
        return _.cloneDeep(line)
    },
    pie() {
        return _.cloneDeep(pie)
    },
    amap() {
        return _.cloneDeep(amap);
    },
    radar() {
        return _.cloneDeep(radar)
    },
    water() {
        return _.cloneDeep(water)
    },
    capsule() {
        return _.cloneDeep(capsule)
    },
    gauge() {
        return _.cloneDeep(gauge)
    },
    scrollTable() {
        return _.cloneDeep(scrollTable)
    },
    border() {
        return _.cloneDeep(border)
    },
    wordCloud() {
        return _.cloneDeep(wordCloud)
    },
    dropDownFilter() {
        return _.cloneDeep(dropDownFilter)
    },
    word() {
        return _.cloneDeep(word)
    },
    card() {
        return _.cloneDeep(card)
    },
    photo() {
        return _.cloneDeep(photo)
    },
    website() {
        return _.cloneDeep(website)
    },
    wall() {
        return _.cloneDeep(wall)
    },
    timer() {
        return _.cloneDeep(timer);
    },
    changePieType(element) {
        let serie = element.option.series[0]
        switch (element.option.type) {

            case 'normal':
                serie.radius = '50%';
                delete serie.roseType;
                return;
            case 'doughnut':
                serie.radius = ['20%', '50%']
                delete serie.roseType;
                return;
            case 'rose':
                serie.radius = ['10%', '60%'], serie.roseType = 'area'
                return;
        }
    },
    digital(element, data) {


        switch (element.type) {
            case 'bar': {
                element.option.dataset = {
                    dimensions: [...element.dataset.dimensions, ...element.dataset.indices],
                    source: data,
                }
                let series = element.dataset.indices.map(() => {
                    return {
                        type: 'bar',
                        label: {
                            show: element.option.seriesLabel.isShowLabel,
                            position: element.option.seriesLabel.labelPosition,
                            color: element.option.seriesLabel.labelColor,
                            fontSize: element.option.seriesLabel.labelFontSize,
                            textBorderColor: element.option.seriesLabel.labelBorderColor,
                            textBorderWidth: element.option.seriesLabel.labelBorderWidth
                        }
                    }
                })
                if (element.option.stackOption === 1) {
                    series.forEach(item => item.stack = true)
                } else if (element.option.stackOption === 2) {
                    series.forEach(item => item.barGap = "-100%");
                }
                element.option.series = series;
                return;
            }
            case 'line':
                element.option.dataset = {
                    dimensions: [...element.dataset.dimensions, ...element.dataset.indices], source: data,
                }

                element.option.series = element.dataset.indices.map(() => {
                    let temp = {
                        type: 'line',
                        smooth: element.option.smooth,
                        symbolSize: element.option.symbolSize,
                        stack: element.option.stack,
                        label: {
                            show: element.option.seriesLabel.isShowLabel,
                            position: element.option.seriesLabel.labelPosition,
                            color: element.option.seriesLabel.labelColor,
                            fontSize: element.option.seriesLabel.labelFontSize,
                            textBorderColor: element.option.seriesLabel.labelBorderColor,
                            textBorderWidth: element.option.seriesLabel.labelBorderWidth
                        }
                    }

                    if (element.option.area)
                        temp.areaStyle = {}
                    return temp;
                });


                return;
            case 'pie':
                if (data.length === 1) {

                    element.option.dataset.source = element.dataset.indices.map(index => {
                        return {
                            name: index,
                            value: data[0][index]
                        }
                    })

                    element.option.series[0].encode.itemName = 'name'
                    element.option.series[0].encode.value = 'value'
                    this.changePieType(element)

                } else {
                    element.option.dataset.source = data
                    element.option.series[0].encode.itemName = element.dataset.dimensions[0]
                    element.option.series[0].encode.value = element.dataset.indices[0]
                    this.changePieType(element)
                }

                return
            case 'water':
                element.option.series[0].data = data;
                return;
            case 'radar':
                element.option.radar.indicator = element.dataset.indices.map(mapper => {
                    return {name: mapper}
                })

                // eslint-disable-next-line no-case-declarations
                let datas = [];

                for (let i = 0; i < data.length; i++) {
                    datas[i] = {
                        name: data[i][element.dataset.dimensions[0]],
                        value: element.dataset.indices.map(mapper => data[i][mapper])
                    }
                }

                element.option.series[0].data = datas;
                return;
            case 'gauge':

                element.option.series[0].data[0] = data[0][element.dataset.indices[0]]
                element.option.series[0].data = _.cloneDeep(element.option.series[0].data)
                // element.option.series[0].detail.formatter = function (value) {
                //     return Math.ceil(value * 100) + '%'
                // }


                return;
            case 'wordCloud':
                element.option.series[0].data = data.map(mapper => {
                    return {
                        name: mapper[element.dataset.dimensions[0]], value: mapper[element.dataset.indices[0]],
                    }
                });

                return;
            case 'capsule':
                element.option.data = data.map(mapper => {
                    return {
                        name: mapper[element.dataset.dimensions[0]], value: mapper[element.dataset.indices[0]],
                    }
                });
                return;
            case 'table':

                // eslint-disable-next-line no-case-declarations
                let array = []

                data.forEach(mapper => {
                    let object = {};
                    element.dataset.dimensions.forEach(key => object[key] = mapper[key]);
                    element.dataset.indices.forEach(key => object[key] = this.format(key, mapper, element))
                    array.push(object);
                });


                element.option.data = array;

                if (element.option.sum) {

                    let sumRow = {};
                    element.dataset.dimensions.forEach(key => sumRow[key] = '');
                    element.dataset.indices.forEach(key => sumRow[key] = 0)

                    for (let i = 0; i < element.dataset.indices.length; i++) {
                        let indexName = element.dataset.indices[i]
                        sumRow[indexName] = 0;
                        data.forEach(row => sumRow[indexName] += row[indexName]);
                        if (!parseInt(sumRow[indexName])) {
                            sumRow[indexName] = '';
                        } else {
                            sumRow[indexName] = this.format(indexName, Math.floor(sumRow[indexName] * 100) / 100, element);
                        }
                    }

                    if (element.option.sumIgnore) {
                        element.option.sumIgnore.split(' ').forEach(ignore => {
                            if (ignore && element.dataset.indices.includes(ignore)) sumRow[ignore] = '';
                        });
                    }

                    sumRow[element.dataset.dimensions[0]] = '合计';
                    element.option.data.unshift(sumRow);
                }


                return;
            case 'scrollTable':
                element.option.header = [...element.dataset.dimensions, ...element.dataset.indices]
                element.option.data = data.map(mapper => {

                    let array = []
                    for (let item of element.dataset.dimensions) {
                        array.push(mapper[item])
                    }

                    for (let index of element.dataset.indices) {
                        array.push(this.format(index, mapper[index], element))
                    }

                    return array;
                });

                if (element.option.sum) {
                    let sumRow = [];

                    for (let i = 0; i < element.option.data[0].length; i++) {
                        if (i === 0) {
                            sumRow[i] = '合计';
                            continue;
                        }
                        sumRow[i] = 0;
                        element.option.data.forEach(row => sumRow[i] += row[i]);
                        if (!parseInt(sumRow[i])) {
                            sumRow[i] = '';
                        } else {
                            sumRow[i] = Math.floor(sumRow[i] * 100) / 100
                        }
                    }

                    if (element.option.sumIgnore) {
                        element.option.sumIgnore.split(' ').forEach(ignore => {
                            if (ignore && element.dataset.indices.includes(ignore))
                                sumRow[element.dataset.dimensions.length + element.dataset.indices.indexOf(ignore)] = '';
                        });
                    }

                    element.option.data.unshift(sumRow);
                }

                return;
            case 'dropDownFilter':
                element.option.options = data
                return;
            case 'card':
                element.option.text = this.format(element.dataset.indices[0], data[0], element)
                element.option = _.cloneDeep(element.option)
                return;
            case 'gantt': {

                element.originalData = data;
                return;
            }

            default:
                console.log('不支持的 dataset 类型');
        }
    },

    /**
     *
     * @param name - 指标名称
     * @param value - 指标的值
     * @param element - 图表元素
     * @returns {*}
     */
    format(name, value, element) {


        try {
            value = value[name];
        } catch (e) {

        }

        if (element.dataset.formats.length > 0 && element.dataset.formats.some(item => item.name === name)) {
            let format = element.dataset.formats.filter(item => item.name === name)[0]
            return value + (format.unit == '无' ? '' : format.unit == '百分位' ? '%' : format.unit) + format.suffix;
        } else {
            return value;
        }
    },

    /**
     * echarts setOption之前，补全函数
     * @param element
     */
    beforeSetOption(element, animationDuration) {

        //仪表盘
        if (element.type === 'gauge') {

            //百分比显示，同步修改 digital方法
            // if(!element.option.series[0].detail.formatter){
            //     element.option.series[0].detail.formatter = function (value) {
            //         return Math.ceil(value * 100) + '%'
            //     }
            // }


        }

        //为词云赋予随机颜色
        if (element.type === 'wordCloud') {
            if (!element.option.series[0].textStyle.color) {
                element.option.series[0].textStyle = {
                    color: function () {
                        return 'rgb(' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ', ' + Math.round(Math.random() * 255) + ')'
                    }
                }
            }

        }

        if (element.option.series && element.option.series.length > 0) {

            element.option.series.forEach(item => {
                delete item.animationDuration;
                delete item.animationEasing;
                item.animationDuration = animationDuration ? animationDuration : 1000;
                item.animationEasing = "cubicInOut"
            });
        }

    },
    async preview(report_id, element, elements, callback) {
        if (element.dataset.dimensions.length < 1 && element.dataset.indices.length < 1) {
            ElNotification({title: '错误', message: '请至少设置一个维护和一个指标', type: 'error',})
            if (callback) callback()
            return;
        }
        element.dataset.additionalConditions = elements.filter(filter => element.dataset.quickLook.indexOf(filter.id) !== -1).flatMap(mapper => {
            try {
                return mapper.toConditions();
            } catch (e) {
                return [];
            }

        });

        //console.log(JSON.stringify(element.dataset.additionalConditions, null, 4))

        useReportStore().preview(report_id, element.id, element.dataset).then(res => {
            this.digital(element, res.data)
            // element.updateTime = res.data.updateTime;
            // element.datasourceUpdateTime = res.data.datasourceUpdateTime;

            //console.log(JSON.stringify(element.option,null,4))

            if (callback) callback()
        })
    }
};
